import React, { useContext } from 'react';
import ObjectsSection from '../ObjectsSection';
import DateRangeSection from '../DateRangeSection';
import BenchmarkSection from '../BenchmarkSection';
import { useRecoilValue } from 'recoil';
import { rightPanelInputsEditable } from 'venn-state';
import { UserContext } from 'venn-components';

export interface LinkableSetupSectionGroupProps {
  hideDateRangeSection?: boolean;
  hideAllocatorLauncher?: boolean;
}

/**
 * @deprecated this component will soon be replaced in Input Management V2.
 * If you make changes here, consider making similar changes to {@link AnalysisBlockTabV2}.
 */
const LinkableSetupSectionGroup = ({ hideDateRangeSection, hideAllocatorLauncher }: LinkableSetupSectionGroupProps) => {
  const { hasPermission } = useContext(UserContext);
  const inputsEditable = useRecoilValue(rightPanelInputsEditable);
  const readonly = !inputsEditable;
  const readOnlyBenchmarks = !hasPermission('STUDIO_EDIT_BENCHMARKS');
  return (
    <>
      {!hideDateRangeSection && <DateRangeSection readonly={readonly} />}
      <ObjectsSection readonly={readonly} hideAllocatorLauncher={hideAllocatorLauncher} />
      <BenchmarkSection readonly={readonly || readOnlyBenchmarks} />
    </>
  );
};

export default LinkableSetupSectionGroup;
